.Text {
  font-family: var(--brand-body-fontFamily);
}

[data-color-mode='dark'] .Text--antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: auto;
}

.Text--default {
  color: var(--brand-color-text-default);
}

.Text--muted {
  color: var(--brand-color-text-muted);
}

.Text-font--mona-sans {
  font-family: var(--brand-body-fontFamily);
}

.Text-font--hubot-sans {
  font-family: var(--brand-body-fontFamilyAlt);
}

.Text-font--monospace {
  font-family: var(--brand-fontStack-monospace);
}

.Text--1000 {
  font-weight: var(--brand-text-weight-1000);
  font-size: var(--brand-text-size-1000);
  line-height: var(--brand-text-lineHeight-1000);
  letter-spacing: var(--brand-text-letterSpacing-1000);
}

.Text--900 {
  font-weight: var(--brand-text-weight-900);
  font-size: var(--brand-text-size-900);
  line-height: var(--brand-text-lineHeight-900);
  letter-spacing: var(--brand-text-letterSpacing-900);
}

.Text--800 {
  font-weight: var(--brand-text-weight-800);
  font-size: var(--brand-text-size-800);
  line-height: var(--brand-text-lineHeight-800);
  letter-spacing: var(--brand-text-letterSpacing-800);
}

.Text--700 {
  font-weight: var(--brand-text-weight-700);
  font-size: var(--brand-text-size-700);
  line-height: var(--brand-text-lineHeight-700);
  letter-spacing: var(--brand-text-letterSpacing-700);
}

.Text--600 {
  font-weight: var(--brand-text-weight-600);
  font-size: var(--brand-text-size-600);
  line-height: var(--brand-text-lineHeight-600);
}

.Text--500 {
  font-weight: var(--brand-text-weight-500);
  font-size: var(--brand-text-size-500);
  line-height: var(--brand-text-lineHeight-500);
}

.Text--400 {
  font-weight: var(--brand-text-weight-400);
  font-size: var(--brand-text-size-400);
  line-height: var(--brand-text-lineHeight-400);
  letter-spacing: var(--brand-text-letterSpacing-400);
}

.Text--350 {
  font-weight: var(--brand-text-weight-350);
  font-size: var(--brand-text-size-350);
  line-height: var(--brand-text-lineHeight-350);
  letter-spacing: var(--brand-text-letterSpacing-350);
}

.Text--300 {
  font-weight: var(--brand-text-weight-300);
  font-size: var(--brand-text-size-300);
  line-height: var(--brand-text-lineHeight-300);
  letter-spacing: var(--brand-text-letterSpacing-300);
}

.Text--200 {
  font-weight: var(--brand-text-weight-200);
  font-size: var(--brand-text-size-200);
  line-height: var(--brand-text-lineHeight-200);
  letter-spacing: var(--brand-text-letterSpacing-200);
}

.Text--100 {
  font-weight: var(--brand-text-weight-100);
  font-size: var(--brand-text-size-100);
  line-height: var(--brand-text-lineHeight-100);
  letter-spacing: var(--brand-text-letterSpacing-100);
}

.Text--weight-heavy,
.Text-narrow--weight-heavy {
  font-weight: var(--base-text-weight-heavy);
}

.Text--weight-extrabold,
.Text-narrow--weight-extrabold {
  font-weight: var(--base-text-weight-extrabold);
}

.Text--weight-bold,
.Text-narrow--weight-bold {
  font-weight: var(--base-text-weight-bold);
}

.Text--weight-semibold,
.Text-narrow--weight-semibold {
  font-weight: var(--base-text-weight-semibold);
}

.Text--weight-medium,
.Text-narrow--weight-medium {
  font-weight: var(--base-text-weight-medium);
}

.Text--weight-normal,
.Text-narrow--weight-normal {
  font-weight: var(--base-text-weight-normal);
}

.Text--weight-light,
.Text-narrow--weight-light {
  font-weight: var(--base-text-weight-light);
}

.Text--weight-extralight,
.Text-narrow--weight-extralight {
  font-weight: var(--base-text-weight-extralight);
}

@media screen and (min-width: 48rem) {
  .Text-regular--weight-heavy {
    font-weight: var(--base-text-weight-heavy);
  }

  .Text-regular--weight-extrabold {
    font-weight: var(--base-text-weight-extrabold);
  }

  .Text-regular--weight-bold {
    font-weight: var(--base-text-weight-bold);
  }

  .Text-regular--weight-semibold {
    font-weight: var(--base-text-weight-semibold);
  }

  .Text-regular--weight-medium {
    font-weight: var(--base-text-weight-medium);
  }

  .Text-regular--weight-normal {
    font-weight: var(--base-text-weight-normal);
  }

  .Text-regular--weight-light {
    font-weight: var(--base-text-weight-light);
  }

  .Text-regular--weight-extralight {
    font-weight: var(--base-text-weight-extralight);
  }
}

@media screen and (min-width: 80rem) {
  .Text-wide--weight-heavy {
    font-weight: var(--base-text-weight-heavy);
  }

  .Text-wide--weight-extrabold {
    font-weight: var(--base-text-weight-extrabold);
  }

  .Text-wide--weight-bold {
    font-weight: var(--base-text-weight-bold);
  }

  .Text-wide--weight-semibold {
    font-weight: var(--base-text-weight-semibold);
  }

  .Text-wide--weight-medium {
    font-weight: var(--base-text-weight-medium);
  }

  .Text-wide--weight-normal {
    font-weight: var(--base-text-weight-normal);
  }

  .Text-wide--weight-light {
    font-weight: var(--base-text-weight-light);
  }

  .Text-wide--weight-extralight {
    font-weight: var(--base-text-weight-extralight);
  }
}

.Text-align--start {
  text-align: start;
}

.Text-align--end {
  text-align: end;
}

.Text-align--center {
  text-align: center;
}
